// =============================================================================
// state
// =============================================================================
const state = {
  holidayList: []
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  holiday_ist: state => state.holidayList
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_holiday (state, value) {
    let holidays = value.holidays;
    let data = {};
    for (let i = 0; i < holidays.length; i++) {
      data[holidays[i].date] = 1;
    }
    state.holidayList = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
